import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';

import type { FunnelStageType, InteractionCardType } from './types';

const useGetBoard = () => {
  const [loading, setLoading] = useState(true);
  const [stages, setStages] = useState<FunnelStageType[]>([]);
  const [interactions, setInteractions] = useState<InteractionCardType[]>([]);

  const getBoard = useCallback(async () => {
    setLoading(true);
    try {
      const [stagesResponse, interactionsResponse] = await Promise.all([
        api.get('/sales_funnel', { params: { pageLimit: 100 } }),
        api.get('/customer_interaction/mine'),
      ]);

      const enabledStages = (stagesResponse.data.data as FunnelStageType[])
        .filter((stage) => stage.is_enabled)
        .sort((a, b) => a.order - b.order);

      setStages(enabledStages);
      setInteractions(interactionsResponse.data);
    } catch (error) {
      toast.error('Erro ao carregar os atendimentos. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to fetch my attendances board'), { error });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getBoard();
  }, [getBoard]);

  return { getBoard, stages, interactions, loading };
};

export default useGetBoard;
